export default {
  kanoon: {
    metaData: {
      competency_category: "v1/enum/competency_category",
      template_category: "v1/enum/template_category",
      assessment_plan_type: "v1/enum/assessment_plan_type",
    },
    company: "v1/company",
    person_company: "v1/company/{0}/person",
    person_content_exercise: "v1/parvandeh/{0}/content/exercise/{1}",
    competency: "v1/competency",
    template_allow_exercise_list: "v1/template/{0}/allow_exercise",
    template_all_exercise_list: "v1/template/{0}/all_exercise",
    template_competency_exercise_indicator:
      "v1/template/{0}/competency_exercise_indicator",
    template_competency_exercise: "v1/template/{0}/competency_exercise",
    template_competency_exercise2: "v2/template/{0}/competency_exercise",
    competency_exercise: "v1/competency_exercise",
    competency_indicator: "v1/competency/{0}/indicator",
    competency_indicator_id: "v1/competency/{0}/indicator/{1}",
    competency_indicator_filter: "v1/competency_indicator",
    template_competency_indicator2: "v1/template/{0}/competency/{1}/indicator",
    indicator_exercise: "v1/indicator/{0}/exercise",
    indicator_evidence: "v1/indicator/{0}/evidence",
    indicator: "v1/indicator",
    indicator_merge: "v1/indicator/{0}/merge",
    exercise: "v1/exercise",
    exercise_id: "v1/exercise/{0}",
    exercise_duplicate: "v1/exercise/{0}/duplicate",
    province: "v1/province",
    city: "v1/city",
    province_city: "v1/province/{0}/city",
    exercise_algorithm: "v1/exercise/{0}/algorithm",
    exercise_algorithm_id: "v1/exercise/{0}/algorithm/{1}",
    exercise_competency: "v1/exercise/{0}/competency",
    exercise_indicator: "v1/exercise/{0}/indicator",
    exercise_indicator_id: "v1/exercise/{0}/indicator/{1}",
    exercise_design_evidence: "v1/exercise_design/{0}/evidence",
    exercise_design: "v1/exercise_design",
    exercise_competency_indicator:
      "v1/exercise/{0}/competency/{1}/indicator/{2}",
    exercise_algorithm_detail: "v1/exercise/{0}/algorithm/{1}/detail",
    algorithm: "v1/algorithm",
    algorithm_detail: "v1/detail",
    template: "v1/template",
    template_id: "v1/template/{0}",
    assessment_plan: "v1/assessment_plan",
    assessment_plan_id: "v1/assessment_plan/{0}",
    assessment_plan_clone: "v1/assessment_plan/{0}/clone",
    assessment_plan_data: "v1/assessment_plan/{0}/data",
    assessment_plan_pseudo_data: "v1/assessment_plan/{0}/pseudo_data",
    assessment_plan_pseudo_data_id: "v1/assessment_plan/{0}/pseudo_data/{1}",
    enum: "v1/enum",
    enum_id: "v1/enum/{0}",
    enum_type: "v1/enum/{type}",
    activity_type: "v1/enum/activity_type",
    activity_time_checkpoint: "v1/enum/activity_time_checkpoint",
    center_execute: "v1/center_execute",
    center_execute_id: "v1/center_execute/{0}",
    day_center_room: "v1/room",
    user: "v1/user",
    role: "v1/role",
    upload_folder: "storage",
    executives: "v1/executives",
    template_duplicate: "v1/template/{0}/duplicate",
    template_competency: "v1/template/{0}/competency",
    template_competency_indicator:
      "v1/template/{0}/competency/{competency_id}/indicator",
    template_competency_indicator_exercise:
      "v1/template/{0}/competency/{1}/indicator/{2}/exercise",
    template_indicator: "v1/template/{0}/indicator",
    template_indicator_exercise:
      "v1/template/{0}/indicator/{indicator_id}/exercise/{exercise_id}",
    template_indicator_exercise_indicator:
      "v1/template/{0}/competency/{1}/exercise/{2}/indicator",
    template_exercise: "v1/template/{0}/exercise/{1}",
    center_execute_person: "v1/center_execute/{0}/person",
    center_execute_parvandeh: "v1/center_execute/{0}/parvandeh/{1}",
    center_execute_absent:
      "v1/center_execute/{0}/center_execute_person/{1}/absent",
    center_execute_room: "v1/center_execute/{0}/room",
    center_execute_room_id: "v1/center_execute/{0}/room/{1}",
    all_center_execute_case: "v1/center_execute_case",
    center_execute_case: "v1/center_execute/{0}/case",
    center_execute_case_overview: "v1/center_execute/{0}/case/{1}/overview",
    center_execute_case_competency: "v1/center_execute/{0}/case/{1}/competency",
    center_execute_case_status: "v1/center_execute/{0}/case/{1}/status",
    center_execute_case_evidence:
      "v1/center_execute/{0}/case/{1}/tcie/{2}/evidence",
    center_execute_case_evidences: "v1/center_execute/{0}/case/{1}/evidence",
    center_execute_case_evidences_by_competency:
      "v1/center_execute/{0}/case/{1}/competency/{2}/evidence",
    center_execute_candidate_overview:
      "v1/center_execute/{0}/candidate/{1}/overview",
    evidence: "v1/evidence",
    evidence_id: "v1/evidence/{0}",
    washup: "v1/center_execute/{0}/washup",
    washup_details:
      "v1/center_execute/{center_execute_id}/washup/candidate/{center_execute_candidate_id}",
    washup_competency_details:
      "v1/center_execute/{center_execute_id}/washup/candidate/{center_execute_candidate_id}/competency/{competency_id}",
    filterData: "v1/filter/{key_filter_name}",
    center_execute_evidence:
      "v1/center_execute/{id}/competency/{competency_id}/indicator/{indicator_id}/exercise/{exercise_id}/evidence",
    center_execute_case_competency_indicator:
      "v1/center_execute/{0}/case/{1}/competency/{2}/indicator",
    center_execute_case_competency_indicator_evidence:
      "v1/center_execute/{0}/case/{1}/competency/{2}/indicator/{3}/evidence",
    center_execute_case_competency_indicator_evidence_like:
      "v1/center_execute/{0}/case/{1}/competency/{2}/indicator/{3}/evidence/{4}/{5}",
    center_execute_case_competency_suggest_score:
      "v1/center_execute/{0}/case/{1}/competency/{2}/score_suggest",
    center_execute_case_final_text:
      "v1/center_execute/{0}/case/{1}/competency/{2}/final_text",
    center_execute_exercise: "v1/center_execute/{0}/exercise",
    attachment: "v1/{0}/{1}/attachment",
    center_execute_report: "v1/center_execute/{0}/report",
    activity: "v1/{0}/{1}/activity",
    activity_id: "v1/{0}/{1}/activities/{2}",
    report_settings: "v1/report_settings?resource=center_execute",
    person_content: "v1/person_content",
    action: "v1/action",
    exercise_indicator_evidence_duplicate:
      "v1/exercise/{0}/indicator/{1}/evidence/duplicate",
    exercise_indicator_evidence_sample:
      "v1/exercise/{0}/indicator/{1}/evidence/{2}/sample",
    center_execute_plan: "v1/center_execute_plan",
    report_integrated: "v1/{0}/{1}/report_integrated",
    filter_cache_resource: "v1/filter_cache",
    place: "v1/place",
    state: "v1/{0}/{1}/state",
    evidence_order: "v1/evidence/order",
    exercise_algorithm_order: "v1/exercise_algorithm/order",
    company_combo: "v1/company/combo",
    term_combo: "v1/term_combo",
    template_combo: "v1/template/combo",
    assessment_plan_combo: "v1/assessment_plan/combo",
    term_state_combo: "v1/term_state_combo",
    center_execute_person_id: "v1/center_execute/{0}/person/{1}",
    person_content_id: "v1/person_content/{0}",
    indicator_id: "v1/indicator/{0}",
    competency_id: "v1/competency/{0}",
    ended_center_execute: "v1/ended_center_execute",
    term_parvandeh_combo: "v1/term/{0}/parvandeh",
    analitical_report: "v1/center_execute/{0}/parvandeh/{1}/report/analytical",
    template_exercise_algorithm: "v1/template/{0}/exercise_algorithm",
    evidence_history_log: "v1/evidence_data/{0}/log",
    import_indicator: "v1/import_indicator",
    evidence_data_id: "v1/evidence_data/{0}",
    competency_coverage_percent:
      "v1/template/{0}/competency/{1}/coverage_percent",
    import_assessment_plan_pseudo_data: "v1/assessment_plan_pseudo_data",
    center_execute_assessment_plan: "v1/center_execute/{0}/assessment_plan",
    parvandeh_set_absent: "v1/center_execute/{0}/case/{1}/set_absent",
    center_execute_state: "v1/center_execute/{0}/state",
    center_execute_plan_id: "v1/center_execute/{0}/plan",
    center_execute_assessor: "v1/center_execute/{0}/assessor",
    change_assessor: "v1/center_execute_case/{0}/change_assessor",
    center_execute_person_content: "v1/center_execute_case/{0}/person_content",
    center_execute_case_content: "v1/center_execute_case/{0}/content",
    center_execute_export: "v1/center_execute/{0}/export",
    center_execute_competency_overview:
      "v1/center_execute/{0}/competency_overview",
    center_execute_create_report:
      "v1/center_execute/{0}/center_execute_person/{1}/report",
    center_execute_score_excel: "v1/center_execute_score_excel",
    kanoon_rebuild_all_reports: "v1/kanoon_rebuild_all_reports",
    center_execute_start_delay: "v1/center_execute/{0}/start_delay",
    evidence_reference: "v1/evidence/{0}/reference",
    centerExecuteAssessmentPlan: "v1/center_execute/{0}/assessment_plan",
    centerExecuteCase: "v1/center_execute/{0}/case",
    oneCenterExecute: "v1/center_execute/{0}",
    centerExecuteExport: "v1/center_execute/{0}/export",
    evidenceHistoryLog: "v1/evidence_data/{0}/log",
    centerExecuteCaseCompetencyIndicator:
      "v1/center_execute/{0}/case/{1}/competency/{2}/indicator/{3}",
    computeCompetencyRecommendedScore:
      "v1/center_execute/{0}/case/{1}/competency/{2}/score_suggest",
    centerExecuteCompetencyOverview: "v1/center_execute/{0}/case/{1}/overview",
    centerExecuteCompetencyIndicatorEvidence:
      "v1/center_execute/{0}/case/{1}/competency/{2}/indicator/{3}/evidence",
    centerExecuteCompetencyIndicatorEvidenceId:
      "v1/center_execute/{0}/case/{1}/competency/{2}/indicator/{3}/evidence/{4}",
    evidenceDataId: "v1/evidence_data/{0}",
    centerExecuteCaseCompetency:
      "v1/center_execute/{0}/case/{1}/competency/{2}",
    centerExecuteCaseCompetencyFinalText:
      "v1/center_execute/{0}/case/{1}/competency/{2}/final_text",
    centerExecutes: "v1/center_execute",
    centerExecute: "v1/center_execute/{0}",
    myCenterExecutes: "v1/fa/kanoon/my-center-executes",
    endedCenterExecutes: "v2/fa/kanoon/ended-center-executes",
    endedCenterExecute: "v2/fa/kanoon/ended-center-executes/{0}",
    centerExecuteState: "v1/center_execute/{0}/state",
    centerExecuteCandidateOverview:
      "v1/center_execute/{0}/candidate/{1}/overview?order_by=model_type:asc-model_id:asc",
    centerExecuteCandidateOverviewId:
      "v1/center_execute/{0}/candidate/{1}/overview/{2}",
    centerExecuteCaseAttachments:
      "v1/fa/kanoon/attachment-center-execute-cases/{0}",
    centerExecuteCaseAttachment:
      "v1/fa/kanoon/attachment-center-execute-cases/{0}/attachment/{1}",
    centerExecutePerson: "v1/center_execute/{0}/person",
    centerExecutePersonId: "v1/center_execute/{0}/person/{1}",
    centerExecuteParvandehId: "v1/center_execute/{0}/parvandeh/{1}",
    centerExecutePersonReport:
      "v1/center_execute/{0}/center_execute_person/{1}/report",
    centerExecuteReport: "v1/center_execute/{0}/report",
    centerExecuteRooms: "v1/center_execute/{0}/room",
    centerExecuteRoom: "v1/center_execute/{0}/room/{1}",
    centerExecuteExercises: "v1/center_execute/{0}/exercise",
    importCenterExecutePerson: "v1/fa/kanoon/import-center-execute-person",
    exportCenterExecuteMeetingBoard:
      "v1/fa/kanoon/export-center-execute-meeting-board",
    centerExecutesChangeState: "v1/fa/kanoon/center-executes-change-state",
    centerExecuteAccess: "v1/fa/kanoon/center-execute-access",
    centerExecuteAccessId: "v1/fa/kanoon/center-execute-access/{0}/{1}",
    importCenterExecuteAccess: "v1/fa/kanoon/import-center-execute-access",
    centerExecuteWithAccess: "v1/fa/kanoon/center-execute-wa",
    incompleteCompletionCenterExecute:
      "v1/fa/kanoon/incomplete-completion-center-execute",
    centerExecuteAttachments: "v1/fa/kanoon/attachment-center-execute/{0}",
    centerExecuteAttachment:
      "v1/fa/kanoon/attachment-center-execute/{0}/attachment/{1}",
    centerExecuteCompleteInfo: "v1/fa/kanoon/center-execute-complete-info",
    centerExecuteDuplicate: "v1/fa/kanoon/center_execute/{0}/duplicate",
    rebuildReport: "v1/rebuild-report",
    centerExecuteActivityAttachments:
      "v1/fa/kanoon/attachment-center-execute-activity/{0}",
    centerExecuteActivityAttachment:
      "v1/fa/kanoon/attachment-center-execute-activity/{0}/attachment/{1}",
    v2: {
      evidence_id: "v2/evidence/{0}",
      centerExecutes: "v2/fa/kanoon/center-executes",
      centerExecute: "v2/fa/kanoon/center-executes/{0}",
      centerExecuteCases: "v2/fa/kanoon/center-executes/{0}/cases",
      allCenterExecuteCaseCompetencies:
        "v2/fa/kanoon/center-execute-cases/{0}/competencies",
      centerExecuteCasePersons:
        "v2/fa/kanoon/center-executes/{0}/cases/{1}/persons",
      centerExecuteCaseCompetenciesIndicators:
        "v2/fa/kanoon/center-executes/{0}/cases/{1}/competencies/{2}/indicators",
      centerExecuteCaseOverview:
        "v2/fa/kanoon/center-executes/{0}/cases/{1}/overview",
      changeAssessor: "v2/fa/kanoon/center-execute-cases/{0}/assessor/change", // ?parvandeh_id=9311&second_assessor_parvandeh_id=9314
    },
  },
};
